import {t,useLanguage} from '../i18n';
import './BenefitsCompact.css';
// src/pages/MyBenefitsPage.jsx
// LOOP D2.9.6 — Client benefits mobile responsive polish
// LOOP D2.9.5 — Client benefits premium container
// Unified client benefits dashboard: memberships + loyalty.

import React, { useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft, Crown, Gift, Sparkles } from "lucide-react";
import MyMembershipsPage from "./MyMembershipsPage";
import MyLoyaltyPage from "./MyLoyaltyPage";
import loopBenefitsCardArt from "../assets/loop-benefits-card-art.png";

const TABS = [
  {
    key: "loyalty",
    label: "Fidelidad",
    eyebrow: "Sellos, puntos y recompensas",
    icon: Gift,
  },
  {
    key: "memberships",
    label: "Membresías",
    eyebrow: "Planes activos, créditos e ilimitados",
    icon: Crown,
  },
];

export default function MyBenefitsPage() {
 useLanguage();
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const tabParam = String(params.get("tab") || "").toLowerCase();
  const initialTab = tabParam === "memberships" ? "memberships" : "loyalty";
  const activeTab = initialTab;

  const activeMeta = useMemo(() => TABS.find((tab) => tab.key === activeTab) || TABS[0], [activeTab]);

  const setTab = (next) => {

    const nextParams = new URLSearchParams(params);
    nextParams.set("tab", next);
    setParams(nextParams, { replace: true });
  };

  return (
    <main className="mbp-page mbp-option-one">
      <style>{styles}</style>

      <div className="mbp-shell">
        <div className="mbp-top">
          <button type="button" className="mbp-back" onClick={() => navigate(-1)}>
            <ArrowLeft size={16} />{t("Volver")}</button>
          <span className="mbp-context-pill">
            <Sparkles size={15} />{t("Beneficios Loop")}</span>
        </div>

        <section className="mbp-hero">
          <div className="mbp-hero-copy">
            <span>{t("Programa de fidelidad")}</span>
            <h1>{t("Mis beneficios")}</h1>
            <p>{t("Tus beneficios, membresías ilimitadas, créditos, sellos y recompensas en un solo lugar.")}<br />{t("Cambia entre membresías y fidelidad según lo que quieras revisar.")}</p>
          </div>

          <div className="mbp-hero-right">
            <div className="mbp-tabs" role="tablist" aria-label={t("Beneficios")}>
              {TABS.map((tab) => {
                const Icon = tab.icon;
                const active = activeTab === tab.key;
                return (
                  <button
                    key={tab.key}
                    type="button"
                    role="tab"
                    aria-selected={active ? "true" : "false"}
                    className={`mbp-tab ${active ? "is-active" : ""}`}
                    onClick={() => setTab(tab.key)}
                  >
                    <Icon size={17} />
                    {t(tab.label)}
                  </button>
                );
              })}
            </div>

            <div className="mbp-hero-art" aria-hidden="true">
              <img src={loopBenefitsCardArt} alt="" />
            </div>
          </div>
        </section>

        <div className="mbp-subnav">
          <span className="mbp-subcopy">
            <strong>{t(activeMeta.label)}</strong>
            {t(activeMeta.eyebrow)}
          </span>
        </div>

        <section className="mbp-panel">
          {activeTab === "memberships" ? <MyMembershipsPage embedded /> : <MyLoyaltyPage embedded />}
        </section>
      </div>
    </main>
  );
}

const styles = `
  .mbp-page {
    min-height: 100dvh;
    background:
      radial-gradient(circle at -10% 18%, rgba(0,103,95,.055), transparent 31%),
      linear-gradient(180deg, #fbfaf7 0%, #ffffff 54%, #fbfaf7 100%);
    color: #0f172a;
    padding: 20px;
    box-sizing: border-box;
  }

  .mbp-shell {
    width: min(1440px, calc(100vw - 64px));
    margin: 0 auto;
  }

  .mbp-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 16px;
  }

  .mbp-back {
    min-height: 42px;
    border-radius: 999px;
    border: 1px solid #dbe4ef;
    background: rgba(255,255,255,.96);
    color: #26364d;
    padding: 0 16px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-weight: 900;
    cursor: pointer;
    box-shadow: 0 12px 28px rgba(15,23,42,.055);
  }

  .mbp-context-pill {
    border: 1px solid rgba(0,103,95,.14);
    background: rgba(240,253,250,.94);
    color: #00675f;
    border-radius: 999px;
    padding: 9px 13px;
    font-size: 12px;
    font-weight: 950;
    display: inline-flex;
    align-items: center;
    gap: 7px;
  }

  .mbp-hero {
    position: relative;
    overflow: hidden;
    min-height: 220px;
    border: 1px solid rgba(218,226,235,.92);
    border-radius: 28px;
    background:
      radial-gradient(circle at 92% 18%, rgba(250,246,238,.96), transparent 34%),
      linear-gradient(135deg, #fffdf9 0%, #ffffff 44%, #fbf6ee 100%);
    box-shadow: 0 18px 42px rgba(15,23,42,.055);
    padding: 34px 38px;
    margin-bottom: 16px;
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(420px, 560px);
    gap: 22px;
    align-items: center;
  }

  .mbp-hero::before {
    content: "";
    position: absolute;
    right: -40px;
    top: -72px;
    width: 760px;
    height: 420px;
    opacity: .62;
    pointer-events: none;
    background:
      repeating-radial-gradient(ellipse at 48% 48%,
        transparent 0 27px,
        rgba(190,151,98,.135) 28px 29px,
        transparent 30px 49px);
    transform: rotate(-9deg);
    mask-image: linear-gradient(90deg, transparent 0%, #000 24%, #000 78%, transparent 100%);
    -webkit-mask-image: linear-gradient(90deg, transparent 0%, #000 24%, #000 78%, transparent 100%);
  }

  .mbp-hero-copy {
    position: relative;
    z-index: 3;
  }

  .mbp-hero-copy span {
    color: #00675f;
    font-size: 11px;
    font-weight: 950;
    letter-spacing: .18em;
    text-transform: uppercase;
  }

  .mbp-hero-copy h1 {
    margin: 13px 0 0;
    font-size: clamp(44px, 5.1vw, 66px);
    line-height: .93;
    letter-spacing: -.072em;
    font-weight: 950;
    color: #0b1428;
    text-rendering: geometricPrecision;
  }

  .mbp-hero-copy p {
    margin: 18px 0 0;
    max-width: 690px;
    color: #5b6b83;
    font-size: 16px;
    line-height: 1.55;
    font-weight: 680;
  }

  .mbp-hero-right {
    position: relative;
    z-index: 4;
    min-height: 170px;
    display: grid;
    align-items: center;
    justify-items: start;
  }

  .mbp-tabs {
    position: relative;
    z-index: 9;
    align-self: center;
    justify-self: start;
    transform: translateX(-8px);
    display: inline-grid;
    grid-template-columns: repeat(2, minmax(158px, 1fr));
    gap: 7px;
    padding: 6px;
    border-radius: 999px;
    border: 1px solid #dbe5ee;
    background: rgba(255,255,255,.90);
    box-shadow: 0 16px 34px rgba(15,23,42,.085);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
  }

  .mbp-tab {
    border: 0;
    border-radius: 999px;
    background: transparent;
    color: #5c6a80;
    min-height: 48px;
    padding: 0 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 9px;
    font-size: 14px;
    font-weight: 950;
    cursor: pointer;
    transition: background 160ms ease, color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
  }

  .mbp-tab:active { transform: scale(.99); }

  .mbp-tab.is-active {
    background: linear-gradient(135deg, #00675f, #007d74);
    color: #ffffff;
    box-shadow: 0 13px 26px rgba(0,103,95,.22);
  }

  .mbp-hero-art {
    position: absolute;
    right: 24px;
    bottom: -12px;
    width: 430px;
    height: 230px;
    pointer-events: none;
    z-index: 5;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    overflow: visible;
  }

  .mbp-hero-art img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: right bottom;
    mix-blend-mode: normal;
    filter: saturate(.98) contrast(1.02) drop-shadow(0 18px 26px rgba(15,23,42,.075));
    user-select: none;
  }

  .mbp-subnav {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    margin: 0 0 14px;
  }

  .mbp-subcopy {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #5d6b81;
    font-size: 13px;
    font-weight: 850;
  }

  .mbp-subcopy strong { color: #0f172a; font-weight: 950; }
  .mbp-panel { border-radius: 30px; }

  @media (max-width: 1100px) {
    .mbp-hero {
      grid-template-columns: 1fr;
      min-height: 0;
      padding-right: 28px;
    }
    .mbp-hero-art { opacity: .34; right: -70px; bottom: -38px; }
    .mbp-tabs { justify-self: start; margin-top: 14px; transform: none; }
  }

  @media (max-width: 760px) {
    .mbp-page {
      padding: 10px 10px 88px;
      background:
        radial-gradient(circle at 0% 0%, rgba(0,103,95,.06), transparent 26%),
        linear-gradient(180deg, #fbfaf7 0%, #ffffff 54%, #fbfaf7 100%);
    }
    .mbp-shell { width: 100%; }
    .mbp-top {
      margin-bottom: 8px;
      position: sticky;
      top: 0;
      z-index: 30;
      padding: 4px 0 6px;
      background: linear-gradient(180deg, rgba(251,250,247,.98), rgba(251,250,247,.72));
      backdrop-filter: blur(12px);
      -webkit-backdrop-filter: blur(12px);
    }
    .mbp-back {
      min-height: 38px;
      padding: 0 13px;
      font-size: 13px;
      box-shadow: 0 8px 18px rgba(15,23,42,.045);
    }
    .mbp-context-pill { display: none; }
    .mbp-hero {
      min-height: 0;
      border-radius: 22px;
      padding: 16px;
      margin-bottom: 10px;
      display: block;
      background:
        radial-gradient(circle at 110% -30%, rgba(0,103,95,.075), transparent 38%),
        linear-gradient(135deg, #fffdf9 0%, #ffffff 64%, #fbf6ee 100%);
      box-shadow: 0 12px 28px rgba(15,23,42,.05);
    }
    .mbp-hero::before,
    .mbp-hero-art { display: none !important; }
    .mbp-hero-copy span {
      font-size: 9.5px;
      letter-spacing: .15em;
    }
    .mbp-hero-copy h1 {
      max-width: 290px;
      margin-top: 8px;
      font-size: clamp(28px, 9vw, 34px);
      line-height: .96;
      letter-spacing: -.065em;
    }
    .mbp-hero-copy p {
      margin-top: 9px;
      max-width: 330px;
      font-size: 12.5px;
      line-height: 1.42;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .mbp-hero-copy p br { display: none; }
    .mbp-hero-right {
      min-height: 0;
      display: block;
      margin-top: 13px;
    }
    .mbp-tabs {
      width: 100%;
      transform: none;
      margin: 0;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 5px;
      padding: 5px;
      border-radius: 18px;
      box-shadow: 0 10px 22px rgba(15,23,42,.07);
      background: rgba(255,255,255,.94);
    }
    .mbp-tab {
      min-height: 40px;
      border-radius: 14px;
      padding: 0 10px;
      font-size: 12.5px;
      gap: 6px;
    }
    .mbp-subnav {
      margin: 0 0 10px;
      align-items: flex-start;
      flex-direction: column;
      gap: 4px;
    }
    .mbp-subcopy {
      display: block;
      font-size: 12.5px;
      line-height: 1.25;
    }
    .mbp-subcopy strong {
      display: inline-block;
      margin-right: 6px;
    }
    .mbp-panel { border-radius: 22px; }
  }

  @media (max-width: 420px) {
    .mbp-page { padding-left: 8px; padding-right: 8px; }
    .mbp-hero { padding: 14px; border-radius: 20px; }
    .mbp-hero-copy h1 { font-size: clamp(26px, 9vw, 31px); }
    .mbp-hero-copy p { font-size: 12px; }
    .mbp-tab { min-height: 38px; font-size: 12px; }
  }

  /* =========================================================
     LOOP MY BENEFITS — MOBILE HEADER GAP FIT V18
     Runtime audit:
     - Chrome mobile: header bottom 58, page top 116 => extra 58px.
     - Native app: header bottom 94, page top 108 => only 14px.
     Goal:
     - Web mobile and native app should have the same visual rhythm:
       header -> ~14px breathing room -> Volver row.
     - Do not change the hero/card layout below.
     ========================================================= */
  @media (max-width: 760px) {
    body:not(.is-mobile-app) .mbp-page {
      margin-top: calc(-1 * var(--loop-global-header-mobile-h, 58px)) !important;
    }

    html.is-mobile-app .mbp-page,
    body.is-mobile-app .mbp-page,
    html.is-android-app .mbp-page,
    body.is-android-app .mbp-page,
    html.is-ios-app .mbp-page,
    body.is-ios-app .mbp-page {
      margin-top: 0 !important;
    }

    .mbp-page {
      padding-top: 10px !important;
    }

    .mbp-shell {
      margin-top: 0 !important;
    }

    .mbp-top {
      margin-top: 0 !important;
    }
  }

  @media (max-width: 420px) {
    body:not(.is-mobile-app) .mbp-page {
      margin-top: calc(-1 * var(--loop-global-header-mobile-h, 58px)) !important;
    }

    html.is-mobile-app .mbp-page,
    body.is-mobile-app .mbp-page,
    html.is-android-app .mbp-page,
    body.is-android-app .mbp-page,
    html.is-ios-app .mbp-page,
    body.is-ios-app .mbp-page {
      margin-top: 0 !important;
    }

    .mbp-page {
      padding-top: 10px !important;
    }
  }


`;
